import {createNamespacedHelpers} from 'vuex';
const {mapGetters, mapMutations} = createNamespacedHelpers('audienceManager/builder');

import {elements} from 'dnx-design';

/**
 * This component will show a list of radio buttons based on a list of options
 * form a vuex store. It will save a the selected value to the vuex store under
 * the provided questionId.
 */
export default {
    name: 'radiolist-question',
    components: {
        RadioButton: elements.RadioButton
    },
    methods: {
        ...mapMutations({
            setQuestionValue(commit, value) {
                commit('setQuestionValue', {
                    questionId: this.questionId,
                    value: value || undefined
                });
            }
        })
    },
    computed: {
        /**
         * Get the name for our radio input elements.
         * @returns {string} Radio input name.
         */
        name() {
            //Name should be something unique; for the time being questionId should suffice
            return this.questionId;
        },
        value: {
            /**
             * Get our selected value from store.
             * @type {String}
             */
            get() {
                const selected = this.options.find((option) =>
                    option.value === this.questionValue(this.questionId)
                );

                return selected ? selected.value : undefined;
            },
            /**
             * Set selected value in store.
             * @param {String} value The selected value
             */
            set(value) {
                //Set value in store.
                this.setQuestionValue(value);
            }
        },
        /**
         * @type {Array<{label: string, value: string}>}
         */
        options() {
            //Get options from store based on quesionId
            return this.questionOptions(this.questionId);
        },
        ...mapGetters(['questionOptions', 'questionValue']),
        ...mapGetters({
            'canEdit': 'canEditAudienceQuestionAnswers'
        })
    },
    props: {
        questionId: {
            type: String,
            required: true,
        }
    }
};